import { checkEmailAvailability as checkEmailAvailabilityRequest } from "@vetty/api-sdk";
import { axiosInstance } from "@/helpers";

export const checkEmailAvailability = async (email: string) => {
  try {
    const { data } = await checkEmailAvailabilityRequest(axiosInstance, {
      email,
    });

    console.log(data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
